import { y as trackProductCardViewed, c as click, h as hasClass, f as removeClass, a as addClass, o as onReady } from './app-chunk-common-BPZAsnhF.js';
import { g as getProductData } from './app-chunk-utils-4zL9DDjt.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const highlightSelector = ".cms-block-product-highlight";

/**
 * @param {HTMLElement} block
 */
const trackCurrentVariantCardViewed = (block) => {
  const productData = getProductData(block);
  const variantId = parseInt(
    // @ts-ignore
    block.querySelector(".is-sold-out-btn").dataset.variantId,
    10
  );
  trackProductCardViewed(productData, variantId, "plp");
};

const initTrackingForBlocks = () => {
  const blocks = document.querySelectorAll(highlightSelector);

  if (blocks.length === 0) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.target) {
        observer.unobserve(entry.target);
        // @ts-ignore
        trackCurrentVariantCardViewed(entry.target);
      }
    });
  });

  blocks.forEach((s) => observer.observe(s));
};

var initCMS = () => {
  initTrackingForBlocks();
};

// We add to any possible containers so we dont add vent handle to every
// child element.
const cmsCollapsibleWrapperSelector = ".cms-block-wrapper__content_collapsible";

var initCollapse = () => {
  click(cmsCollapsibleWrapperSelector, (container, e) => {
    if (e.target.matches("[data-collapse-trigger]")) {
      e.preventDefault();
      const isOpen = hasClass(e.target.parentNode, "is-open");
      const allTriggers = container.querySelectorAll("[data-collapse-trigger]");

      for (let i = 0; i < allTriggers.length; i++) {
        const trigger = allTriggers[i];
        removeClass(trigger.parentNode, "is-open");
      }

      if (isOpen === false) {
        addClass(e.target.parentNode, "is-open");
      }
    }
  });
};

const initKlaviyoForms = () => {
  if (window["NUUN_STORE_COUNTRY"] !== "usa") {
    return;
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type == "submit" && e.detail.formId == "TAF2H6") {
      pintrk("track", "signup", {
        lead_type: "LET'S GET MUUVING TOGETHER!",
      });
      return;
    }

    if (e.detail.type == "submit" && e.detail.formId == "RXgCTb") {
      ga("send", {
        hitType: "event",
        eventCategory: "CTA buttons",
        eventAction: "Subscribe",
        eventLabel: "Adventure Subscribe",
      });
      return;
    }

    if (e.detail.type == "submit" && e.detail.formId == "VddegH") {
      ga("send", {
        hitType: "event",
        eventCategory: "CTA buttons",
        eventAction: "Subscribe",
        eventLabel: "ECH Guide",
      });
      return;
    }
  });
};

onReady(() => {
  initCMS();
  initCollapse();
  initKlaviyoForms();
});
